// extracted by mini-css-extract-plugin
export var listElement = "styles-module--list-element--3LnbX";
export var listElementImage = "styles-module--list-element-image--16pyZ";
export var listElementWithCaption = "styles-module--list-element-with-caption--foBbj";
export var listElementContent = "styles-module--list-element-content--3I6ui";
export var listElementGridItem = "styles-module--list-element-grid-item--14I0M";
export var withIcon = "styles-module--withIcon--319I4";
export var icon = "styles-module--icon--D3DSW";